import React from "react";
import "./Header.css";

export const Header = (props) => {
  if (!props.data) return null;

  // Split title into static and dynamic parts
  const title = props.data.title || "Loading Title";
  const words = title.split(" ");
  const staticText = words.slice(0, -3).join(" ");
  const dynamicText = words.slice(-3).join(" ");

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text text-center">

                {/* Static + Dynamic typing */}
                <h1 className="typing-title">
                  <span className="static">{staticText} </span>
                  <span className="dynamic">{dynamicText}</span>
                </h1>

                {/* Subtitle */}
                <p className="fade-in-subtitle">
                  {props.data.paragraph}
                </p>

                {/* Button */}
                <a
                  href="#about"
                  className="btn btn-custom btn-lg page-scroll fade-in-btn"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
